import * as React from "react";
import type { SVGProps } from "react";
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 21 20" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.708 6.667V5a3.958 3.958 0 1 1 7.917 0v1.667h.208A3.333 3.333 0 0 1 18.167 10v5a3.333 3.333 0 0 1-3.334 3.333H6.5A3.333 3.333 0 0 1 3.167 15v-5A3.333 3.333 0 0 1 6.5 6.667zM7.958 5a2.708 2.708 0 1 1 5.417 0v1.667H7.958zm-3.541 5c0-1.15.932-2.083 2.083-2.083h8.333c1.151 0 2.084.932 2.084 2.083v5c0 1.15-.933 2.083-2.084 2.083H6.5A2.083 2.083 0 0 1 4.417 15z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLock;
